import { useLazyTermItemsQuery } from '../../../graphql/graphql';
import { SelectValue } from '../Components/Select';

type termItemKey = 'id' | 'termId' | 'name' | 'value' | 'value2' | 'value3';

export default function useTermItems(termType: string) {
	const [getTermItems] = useLazyTermItemsQuery();

	const getAsSelectValues = async ({
		labelKey = 'name',
		valueKey = 'id',
	}: {
		labelKey?: termItemKey;
		valueKey?: termItemKey;
	}): Promise<SelectValue[]> => {
		const options: SelectValue[] = [];

		const data = await getTermItems({ termType, take: 999 });

		data?.data?.termItems?.data?.forEach(termItem => {
			if (termItem?.[labelKey] && termItem?.[valueKey]) {
				options.push({
					label: termItem[labelKey] ?? '',
					value: termItem[valueKey] ?? '',
				});
			}
		});

		return options;
	};

	return { getAsSelectValues };
}
